import { render, staticRenderFns } from "./ModalConfirmAuthorization.vue?vue&type=template&id=49ae10da&"
import script from "./ModalConfirmAuthorization.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports